<script lang="ts">
	import { IconButton } from '@Shelly/shelly-design-system';
	import { home_data } from 'src/stores/account/user';
	import { save_home } from 'src/helpers/home_helpers';

	const updateHomeData = () => {
		// const homeDataLayout = $home_data.showNewsletter || {};
		save_home('newsletterPrompt', {
			seen: false,
		});

		home_data.set({
			...$home_data,
			newsletterPrompt: {
				seen: false,
			},
		});
	};
</script>

<IconButton class="mr-s" icon="fas fa-envelope" on:click={updateHomeData}
	>Reset Newsletter Pop-up</IconButton
>
